module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/392.084251f0.png";